import { EntityInterface } from '../interfaces/entityInterface.model';

export class AbstractEntity implements EntityInterface {
    updateUsername?: string;
    updateDatetime?: Date;
}
